module.exports = __webpack_public_path__ + "img/rejected-private.133bfb3e.png";